/**
* ENGLanguagePackContentType.js
* 
* Created on Oct 3, 2013, 12:24:50 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/

const ENGLanguagePackContentType = {
    TEXT: "text",
    AUDIO: "audio",
    MOVIE: "movie",
    IMAGE: "image",
    SWF: "swf"
};

export default ENGLanguagePackContentType;